export default {
  xs: '768px',
  sm: '992px',
  md: '1200px',
}



// WEBPACK FOOTER //
// ./src/styles/breakpoints.js